module.exports = __webpack_public_path__ + "static/logo-quiksilver-new-1b760fa35066e2bb30c9df5ec74384b8.png";